export const environment = {
  version: '26a471370ec0ee71df34578d1900b9ae6477a1d2',
  buildDate: '202610261024',
  environment: 'feature-candidate-platform',
  production: false,
  debug: true,
  dash0Enabled: true,
  baseUrl: 'https://develop.jobboard.catch-talents.dev',
  apiBaseUrl: 'https://feature-candidate-platform.api.catch-talents.dev',
  apiBaseUrlFallback: 'https://develop.api.catch-talents.dev',
  googleClientId:
    '691717356112-hcccatjr7pt1o2srjb1pq2c79nu6trgm.apps.googleusercontent.com',
  friendlyCaptchaV2SiteKey: 'FCMPE7D6EN3BAEGN',
};
